import { Helper } from "./helper.js";
import { HTTPService, HTTPRequestType } from "./httpManager.js";
import { Config } from "../config/config.js";
import { BaseField, HttpRequest } from "../components/baseComponentProps.js";
import { MetadataRegion } from "../components/region.js";
import { Entity, Metadata } from "../components/commonApp.js";

export class MetaDataHelper {
    public static getFieldValue(entity: Entity, model: string) {
        var tmpModel = model;
        if (model.indexOf("entity.") === 0) {
            tmpModel = tmpModel.replace("entity.", "");
        }
        return Helper.getValueByPathString(entity, tmpModel);
    }

    public static setFieldValue(entity: Entity, model: string, value) {
        var entityAndfield = model.split(".");
        var tmpEntity = entity;
        // Durchlauf Objektstruktur entity.[1..n fields]
        for (var i = 1; i < entityAndfield.length - 1; i++) {
            tmpEntity = tmpEntity[entityAndfield[i]];
        }
        tmpEntity[entityAndfield[entityAndfield.length - 1]] = value;
    }

    // Setzt die ReadOnly Angabe von Elementen in Abhängigkeit des angegebenen Models
    public static setReadOnly(metadata: Metadata, modelValue, readOnly: string | boolean) {
        for (var i = 0; i < metadata.tabs.length; i++) {
            if (metadata.tabs[i].regions != null) {
                for (var y = 0; y < metadata.tabs[i].regions.length; y++) {
                    if (metadata.tabs[i].regions[y].fields != null) {
                        for (var z = 0; z < metadata.tabs[i].regions[y].fields.length; z++) {
                            if (metadata.tabs[i].regions[y].fields[z].model === modelValue) {
                                metadata.tabs[i].regions[y].fields[z].readOnly = readOnly;
                            }
                        }
                    }
                }
            }
        }
    }

    // Setzt die Sichtbarkeit von Elementen in Abhängigkeit des angegebenen Models
    public static setVisibility(metadata: Metadata, modelValue, visible: boolean) {
        for (let i = 0; i < metadata.tabs.length; i++) {
            if (metadata.tabs[i].regions != null) {
                for (let y = 0; y < metadata.tabs[i].regions.length; y++) {
                    if (metadata.tabs[i].regions[y].fields != null) {
                        for (let z = 0; z < metadata.tabs[i].regions[y].fields.length; z++) {
                            if (metadata.tabs[i].regions[y].fields[z].model === modelValue) {
                                metadata.tabs[i].regions[y].fields[z].visible = visible;
                            }
                        }
                    }
                }
            }
        }
    }

    public static setFieldVisibility(metadata: Metadata, name: string, visible: boolean) {
        for (let i = 0; i < metadata.tabs.length; i++) {
            if (metadata.tabs[i].regions != null) {
                for (let y = 0; y < metadata.tabs[i].regions.length; y++) {
                    if (metadata.tabs[i].regions[y].fields != null) {
                        for (let z = 0; z < metadata.tabs[i].regions[y].fields.length; z++) {
                            if (Helper.getValueOrDefault(metadata.tabs[i].regions[y].fields[z].name, "") === name) {
                                metadata.tabs[i].regions[y].fields[z].noSearchResult = !visible;
                            }
                        }
                    }
                }
            }
        }
    }

    public static setRegionVisibility(metadata: Metadata, regionTitle: string, tabTitle: string, visible: boolean) {
        for (let i = 0; i < metadata.tabs.length; i++) {
            if (metadata.tabs[i].regions != null) {
                for (let y = 0; y < metadata.tabs[i].regions.length; y++) {
                    if ((Helper.getValueOrDefault(metadata.tabs[i].regions[y].title, "") == regionTitle) && (Helper.getValueOrDefault(metadata.tabs[i].title, "") == tabTitle)) {
                        metadata.tabs[i].regions[y].noSearchResult = !visible;
                    }
                }
            }
        }
    }

    public static setTabVisibility(metadata: Metadata, title: string, visible: boolean) {
        for (let i = 0; i < metadata.tabs.length; i++) {
            if (Helper.getValueOrDefault(metadata.tabs[i].title, "") == title) {
                metadata.tabs[i].noSearchResult = !visible;
            }
        }
    }

    // Setzt die Pflichtangabe von Elementen in Abhängigkeit des angegebenen Models
    public static setRequired(metadata: Metadata, modelValue, required: string | boolean) {
        for (let i = 0; i < metadata.tabs.length; i++) {
            if (metadata.tabs[i].regions != null) {
                for (let y = 0; y < metadata.tabs[i].regions.length; y++) {
                    if (metadata.tabs[i].regions[y].fields != null) {
                        for (let z = 0; z < metadata.tabs[i].regions[y].fields.length; z++) {
                            if (metadata.tabs[i].regions[y].fields[z].model === modelValue) {
                                metadata.tabs[i].regions[y].fields[z].required = required;
                            }
                        }
                    }
                }
            }
        }
    }

    public static getObjectFromAdditional(metaData: Metadata, objectName: string): any {
        if (Helper.hasValue(metaData) && Helper.hasValue(metaData.additional) && Array.isArray(metaData.additional.objects)) {
            for (let i = 0; i < metaData.additional.objects.length; i++) {
                if (metaData.additional.objects[i].name === objectName) {
                    return metaData.additional.objects[i].data;
                }
            }
        }

        return null;
    }

    public static getFieldByProperty(metadata: Metadata, property: string, value: any): any {
        if (!Helper.hasValue(metadata) || !Helper.hasValue(property) || !Helper.hasValue(value)) {
            return null;
        }

        for (let i = 0; i < metadata.tabs.length; i++) {
            const tab = metadata.tabs[i];
            if (Array.isArray(tab.regions)) {
                for (let j = 0; j < tab.regions.length; j++) {
                    const region = tab.regions[j];
                    if (Array.isArray(region.fields)) {
                        for (let k = 0; k < region.fields.length; k++) {
                            if (region.fields[k][property] === value) {
                                return region.fields[k];
                            }
                        }
                    }
                }
            }
        }
    }

    public static getPropertiesWithDefaultValues = (metadata: Metadata) => {
        const props: Array<BaseField> = [];
        const hasValue = Helper.hasValue;

        if (hasValue(metadata) && Array.isArray(metadata.tabs)) {
            metadata.tabs.forEach(t => {
                if (Array.isArray(t.regions)) {
                    t.regions.forEach(r => {
                        if (Array.isArray(r.fields)) {
                            r.fields.forEach(f => {
                                if (hasValue(f.defaultValue) || hasValue(f.defaultValueModifier)) {
                                    props.push(f);
                                }
                            });
                        }
                    });
                }
            });
        }

        return props;
    }

    /*
     * supported tokens: 
     *      value -> value set by "defaultValue"
     *      today -> current date, no time
     *      + <days> -> add days
     *      plus <days> -> see "+"
     */
    public static setDefaultValues = (metadata: Metadata, entity: Entity) => {
        const props = MetaDataHelper.getPropertiesWithDefaultValues(metadata);
        const hasValue = Helper.hasValue;

        const processToken = (text: string, startDate: Date = null, startString: string = null, startNumber: number = null) => {
            const tokens = text.split(" ");
            let tmpDate: Date = startDate;
            let tmpString: string = startString;
            let tmpNumber: number = startNumber;
            //TODO: string value, number value...

            let idx = 0;
            while (idx < tokens.length) {
                if (tokens[idx].trim() !== "") {
                    switch (tokens[idx]) {
                        case "today":
                            tmpDate = MetaDataHelper.defaultTokens.date.today();
                            break;
                        case "+":
                        case "plus":
                            idx++;
                            const days = parseInt(tokens[idx], 10);
                            tmpDate = MetaDataHelper.defaultTokens.date.plusDays(tmpDate, days);
                            break;
                        default:
                            break;
                    }
                }

                idx++;
            }

            if (tmpDate !== null) {
                return tmpDate
            } else if (tmpString !== null) {
                return tmpString;
            } else if (tmpNumber !== null) {
                return tmpNumber;
            }
            let con = MetaDataHelper.getConfigResult(text);
            if (con !== null) {
                return con;
            }
            return null;
        }

        props.forEach(p => {
            if (hasValue(p.defaultValue)) {
                //string means that it could be a template
                if (typeof p.defaultValue === "string") {
                    let value = p.defaultValue;
                    //if it's a template, it will be processed
                    //if not, it will return the original string
                    const finalValue = Helper.processTemplate(value, (match) => {
                        const value = processToken(match);
                        if (typeof value === "string") {
                            return value;
                        } else if (typeof value === "number") {
                            return value.toString();
                        } else if (value instanceof Date) {
                            return Helper.dates.toString(value, false);
                        } else if (typeof value === "object") {
                            return value;
                        }
                        //TODO
                        return null;
                    });
                    MetaDataHelper.setFieldValue(entity, p.model, finalValue);
                } else if (typeof p.defaultValue === 'object') {
                    MetaDataHelper.setValueByHttpRequest(p.defaultValue, (value: any) => {
                        MetaDataHelper.setFieldValue(entity, p.model, value);
                    });
                } else {
                    MetaDataHelper.setFieldValue(entity, p.model, p.defaultValue);
                }
            }

            if (hasValue(p.defaultValueModifier)) {
                let startDate: Date = null, startString: string = null, startNumber: number = null;
                let tmpDefaultValueModifier = p.defaultValueModifier.toLowerCase().trim();
                if (tmpDefaultValueModifier.indexOf("value") === 0) {
                    const value = MetaDataHelper.getFieldValue(entity, p.model);
                    tmpDefaultValueModifier = tmpDefaultValueModifier.substring(5);
                    if (p.type === "kendo-date-picker" || p.type === "kendo-date-time-picker") {
                        startDate = value;
                    } else {
                        //TODO: switch between number and string...
                        startString = hasValue(value) ? value.toString() : value;
                    }
                }

                const finalValue = processToken(tmpDefaultValueModifier, startDate, startString, startNumber);
                MetaDataHelper.setFieldValue(entity, p.model, finalValue);
            }
        });
    }

    public static getConfigResult = (value: string): any => {
        let arr = value.split(".");
        if (arr.length > 0 && arr[0] == "Config") {
            let obj: any = Config;
            for (let i = 1; i < arr.length; i++) {
                obj = obj[arr[i]];
            }
            return obj;
        } else {
            return null;
        }
    }

    public static setValueByHttpRequest = (obj: any, setter: (value: any) => void) => {
        let keys = Object.keys(obj);
        if (keys.indexOf("url") > -1) {
            const executeHTTPRequest = async (requestData: HttpRequest) => {
                const formData = new FormData();
                if (keys.indexOf("params") > -1) {
                    requestData.params.forEach((item: { key: string, value: any }) => {
                        formData.append(item.key, item.value);
                    });
                }
                let result = null;
                if (requestData.requestType === "get")
                    result = await HTTPService.get(requestData.url, formData);
                else
                    result = await HTTPService.post(requestData.url, formData);
                if (Helper.hasValue(result))
                    setter(result.Data);
            }
            executeHTTPRequest(obj as HttpRequest);
        } else if (keys.indexOf("api") > -1) {
            const executeDynamicApi = async (requestData: HttpRequest) => {
                let url = `Statistic/api/dynamicapi/${requestData.api}/GetData`;
                if (keys.indexOf("params") > -1) {
                    requestData.params.forEach((item: { key: string, value: any }, index: number) => {
                        if (index > 0) {
                            url += `&${item.key}=${item.value}`;
                        } else {
                            url += `?${item.key}=${item.value}`;
                        }
                    });
                    let result: [{}] = await HTTPService.get(url);
                    if (result.length > 0) {
                        let data = result[0];
                        if (keys.indexOf("field") > -1) {
                            let value = data[requestData.field.toUpperCase()];
                            if (Helper.hasValue(value)) {
                                setter(value);
                            }
                        } else {
                            let columns = Object.keys(data);
                            if (columns.length > 0) {
                                let value = data[columns[0]];
                                if (Helper.hasValue(value)) {
                                    setter(value);
                                }
                            }
                        }
                    }
                }
            }
            executeDynamicApi(obj as HttpRequest);
        }
    }

    private static defaultTokens = {
        date: {
            today: () => {
                const d = new Date();
                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            },
            plusDays: (date: Date, days: number) => Helper.dates.addDays(date, days)
        },
        string: {},
        number: {},
        list: {}
    }

    public static setGUIDs = (metadata: Metadata) => {
        if (Helper.hasValue(metadata) && Array.isArray(metadata.tabs)) {
            metadata.tabs.forEach(tab => {
                tab.guid = kendo.guid();
                if (Array.isArray(tab.regions)) {
                    tab.regions.forEach(region => {
                        region.guid = kendo.guid();
                        if (Array.isArray(region.fields)) {
                            region.fields.forEach(field => {
                                field.guid = kendo.guid();
                            })
                        }
                    });
                }
            });
        }
    }

    public static getFieldByModelName(metadata: Metadata, model: string): BaseField {
        if (Helper.hasValue(metadata) && Array.isArray(metadata.tabs) && Helper.hasValue(model)) {
            for (let tab of metadata.tabs) {
                if (Array.isArray(tab.regions)) {
                    for (let region of tab.regions) {
                        if (Array.isArray(region.fields)) {
                            for (let field of region.fields) {
                                if (field.model === model)
                                    return field
                            }
                        }
                    }
                }
            }
        }

        return null;
    }
    public static getLayoutRegions = (regions: MetadataRegion[]) => {
        let layoutRegions: MetadataRegion[] = [];

        if (Array.isArray(regions)) {
            regions.forEach(region => {
                const hasLayoutProps = !Helper.isNullOrEmpty(region.breakStart) || Helper.hasValue(region.size);
                if (hasLayoutProps && (!Array.isArray(region.fields) || region.fields.length === 0)) {
                    layoutRegions.push(region);
                }
            });
        }

        return layoutRegions;
    }
}